import { render, staticRenderFns } from "./HolidayPromoBanner.vue?vue&type=template&id=96a6575e&scoped=true&"
import script from "./HolidayPromoBanner.vue?vue&type=script&lang=js&"
export * from "./HolidayPromoBanner.vue?vue&type=script&lang=js&"
import style0 from "./HolidayPromoBanner.vue?vue&type=style&index=0&id=96a6575e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a6575e",
  null
  
)

export default component.exports